'use strict';
var novicell = novicell || {};
const globalHeader = document.getElementById('js-site-navigation');

if (globalHeader) {
    new Vue({
        el: globalHeader,
        name: 'globalHeader',
        data: {
            hasBackground: false,
            onlyBgOutsideTopBanner: false,
            burgerActive: false,
            showDropDown:{},
            showMobileDropDownLevel2:{},
            showMobileDropDownLevel3:{},
            languagePicker:null,
            languagePickerList:null,
            languagePickerActiveClass: 'language-picker--active',
            searchIsOpen: false,
            searchInput: null
        },
        mounted() {
            const pageHeader = document.getElementsByClassName('top-banner');
            
            if (!pageHeader.length) {
                this.hasBackground = true;
            } else {
                this.onlyBgOutsideTopBanner = true;
                this.handleScroll(pageHeader[0]);
            }
            document.addEventListener('scroll', () => {
                this.handleScroll(pageHeader[0]);
            });

            document.addEventListener('touchend', () => {
                this.hideAllDropDowns();
            });
            this.languagePicker = this.$refs.languagePicker;
            this.languagePickerList = this.$refs.languagePickerList;
            this.searchInput = this.$refs.searchInputField;
        },
        methods: {
            languagePickerClickTrigger(e){
                e.preventDefault();

                this.languagePickerCloseOverlayHandler();
                this.languagePicker.classList.add(this.languagePickerActiveClass);
            },
            languagePickerCloseOverlayHandler() {
                document.addEventListener('keydown', this.languagePickerHandleEsc, true);
                document.addEventListener('click', this.languagePickerHandleClick, true);
            },
            languagePickerCloseLanguagePicker() {
                document.removeEventListener('click', this.handleClick, true);
            },
            languagePickerHandleClick(e) {
                var targetElement = e.target;
                do {
                    if (targetElement == this.languagePickerList) {
                        // This is a click inside. Do nothing, just return.
                        return;
                    }
                    targetElement = targetElement.parentNode;
                } while (targetElement);
        
                // This is a click outside.
                this.languagePickerCloseLanguagePicker();
            },
            handleScroll(pageHeader) {
                if (this.onlyBgOutsideTopBanner) {
                    const pageHeaderRect = pageHeader.getBoundingClientRect();
                    const globalHeaderRect = this.$el.getBoundingClientRect();
                    this.hasBackground = (pageHeaderRect.top - globalHeaderRect.height) + pageHeaderRect.height <= 0;
                }
            },
            toggleBurgerActive() {
                this.burgerActive = !this.burgerActive;
                if(this.burgerActive) {
                    this.hideAllMobileDropDownsLevel2();
                    this.hideAllMobileDropDownsLevel3();
                    this.foldOutMobileNavOnOpen();
                }
                novicell.helper.toggleClass(document.body, 'no-scroll');
            },
            stopProp(e){
                e.stopPropagation();
            },
            hideAllDropDowns(){
                Object.keys(this.showDropDown).forEach((key) =>{
                    Vue.set(this.showDropDown, key, false);
                });
            },
            mobileFindTriggerAndClick(triggerParent){
                const triggerLevel = triggerParent.children;
                const triggerLevelArray = Array.prototype.slice.call(triggerLevel);
                const trigger = triggerLevelArray.filter(el => el.classList.contains('site-navigation-list__sub-navigation-toggle'))[0];
                if(trigger) {
                    trigger.click();
                }
            },
            foldOutMobileNavOnOpen(){
                const activePage = this.$refs.selected;
                if(activePage){
                    let activePageLevel = 4;
                    if(activePage.classList.contains('sub-navigation__item--level-2')) {
                        activePageLevel = 2;
                    }
                    if(activePage.classList.contains('sub-navigation__item--level-3')) {
                        activePageLevel = 3;
                    }
                    // const activePageLevel = activePage.classList.contains('sub-navigation__item--level-2 ') ? 2 : 3;
                    if(activePageLevel === 2) {
                        const triggerParent = activePage.parentElement.parentElement.parentElement.parentElement;
                        this.mobileFindTriggerAndClick(triggerParent);
                    }else if(activePageLevel === 3) {
                        const triggerParent3 = activePage.parentElement.parentElement;
                        this.mobileFindTriggerAndClick(triggerParent3);
                        const triggerParent2 = activePage.closest('.site-navigation-list__item');
                        this.mobileFindTriggerAndClick(triggerParent2);
                    }
                    else if(activePageLevel === 4) {
                        const triggerParent3 = activePage.parentElement.parentElement.parentElement.parentElement;
                        this.mobileFindTriggerAndClick(triggerParent3);
                        const triggerParent2 = activePage.closest('.site-navigation-list__item');
                        this.mobileFindTriggerAndClick(triggerParent2);
                    }
                }
            },
            hideAllMobileDropDownsLevel2(){
                Object.keys(this.showMobileDropDownLevel2).forEach((key) =>{
                    Vue.set(this.showMobileDropDownLevel2, key, false);
                });
            },
            hideAllMobileDropDownsLevel3(){
                Object.keys(this.showMobileDropDownLevel3).forEach((key) =>{
                    Vue.set(this.showMobileDropDownLevel3, key, false);
                });
            },
            toggleNavigation(e,elId) {
                var mediaQuery = window.matchMedia("(min-width: 1200px)");
                if (mediaQuery.matches) { // If media query matches
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    let show = false;
                    if(!this.showDropDown[elId]) {
                        show = true;
                    }
                    this.hideAllDropDowns();
                    Vue.set(this.showDropDown, elId, show);
                }
            },
            toggleMobileSubLevel3(elId) {
                let show = false;
                if(!this.showMobileDropDownLevel3[elId]) {
                    show = true;
                }
                // this.hideAllMobileDropDownsLevel3();
                Vue.set(this.showMobileDropDownLevel3, elId, show);
            },
            toggleMobileSubLevel2(elId) {
                let show = false;
                if(!this.showMobileDropDownLevel2[elId]) {
                    show = true;
                }
                // this.hideAllMobileDropDownsLevel2();
                Vue.set(this.showMobileDropDownLevel2, elId, show);
            },
            searchButtonClick(e,elId){
                if (!this.searchIsOpen) {
                    this.openSearchOverlay();
                } else {
                    this.closeSearchOverlay();
                }
                this.toggleNavigation(e,elId);
            },
            openSearchOverlay() {
                // document.addEventListener('keydown', handleEsc, true);
                document.addEventListener('click', this.searchHandleClick, true);
                document.body.classList.add('search-overlay-open');
                this.searchInput.focus();
        
                this.searchIsOpen = true;
            },
            closeSearchOverlay() {
                document.body.classList.remove('search-overlay-open');
                this.searchInput.blur();
                this.searchInput.value = '';
                // document.removeEventListener('keydown', handleEsc, true);
                document.removeEventListener('click', this.searchHandleClick, true);
        
                this.searchIsOpen = false;
            },
            searchHandleClick(e) {
                var targetElement = e.target;
        
                if (targetElement.closest('.js-search-overlay') || targetElement.closest('.js-search-overlay-trigger')) {
                    return;
                }
        
                // This is a click outside.
                this.closeSearchOverlay();
            }
        }
    });
}
